module.exports = __webpack_public_path__ + "img/cert-del.151a970c.svg";